import React from "react";
import "./Footer.css";
function Footer() {
  return (
    <div>
      <div className="footer">
        <div className="footer-content">
          <div className="info">
            <h1>INFO</h1>
            <a href="#">FAQ</a>
            <a href="#">Terms of use</a>
            <a href="#">Privacy Policy</a>
            <a href="#">Lisences</a>
          </div>
          <div className="follow-us">
            <h1>Follow Us</h1>
            <a href="#" target="_blank">
              <img
                src="\assets\images\social-icons\telegram.svg"
                alt="telegram"
              />
            </a>
            <a href="#" target="_blank">
              <img
                src="\assets\images\social-icons\discord.svg"
                alt="discord"
              />
            </a>
            <a href="#" target="_blank">
              <img
                src="\assets\images\social-icons\facebook.svg"
                alt="facebook"
              />
            </a>
            <a href="#" target="_blank">
              <img
                src="\assets\images\social-icons\twitter.svg"
                alt="twitter"
              />
            </a>
            <a href="#" target="_blank">
              <img
                src="\assets\images\social-icons\instagram.svg"
                alt="instagram"
              />
            </a>
            <a href="#" target="_blank">
              <img
                src="\assets\images\social-icons\youtube.svg"
                alt="youtube"
              />
            </a>
            <a href="#" target="_blank">
              <img
                src="\assets\images\social-icons\linkedin.svg"
                alt="linkedin"
              />
            </a>
            <p>Copyright Astrality. All Rights Reserved</p>
          </div>
          <div className="newsletter">
            <h1>Newsletter</h1>
            <input type="email" name="" placeholder="Enter your Email" id="" />
            <button>Subscribe</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
